import { CommandToken } from '@/Admin/TicketTemplate/Types';

export interface FeedMultipleLines extends CommandToken {
    lineCount: number;
}

export interface SetFont extends CommandToken {
    fontSize: FontSize;
}

export enum FontSize {
    Small = 0x02,
    Medium = 0x01,
    Large = 0x00
}

export interface SetHorizontalAlignment extends CommandToken {
    alignment: HorizontalAlignment;
}

export enum HorizontalAlignment {
    Left = 0x00,
    Center = 0x01,
    Right = 0x02
}

export interface SetTabs extends CommandToken {
    // Newtonsoft.JSON serializes C# byte arrays as Base64
    tabs: string;
}

export interface SetMargin extends CommandToken {
    margin: number;
}

export interface SetLineFeedSize extends CommandToken {
    size: LineFeedSize;
}

export enum LineFeedSize {
    ThreeMM = 0x00,
    FourMM = 0x01,
}

export interface SetPageLength extends CommandToken {
    pageLines: number;
}

export interface Image extends CommandToken {
    imageData: string;
    bitmapByteArray: string;
}
